








import { inject } from 'inversify-props'
import { Component, Vue } from 'vue-property-decorator'
import IVersionInfo from '@master/config/IVersionInfo'
import moment from 'moment'

@Component
export default class TheFooter extends Vue {
  @inject()
  private ifamVersion: IVersionInfo

  @inject()
  private projectVersion: IVersionInfo

  private changelog = []

  loadJSON () {
    try {
      this.changelog = require('@/config/changelog.json').changeLog
    } catch (error) {
      console.error(error)
    }
  }

  beforeMount () {
    this.loadJSON()
  }

  get latestVersion () {
    return this.changelog?.length ? this.changelog[0].version : '-'
  }

  get latestDate () {
    return this.changelog?.length ? moment(this.changelog[0].time).format('DD/MM/YYYY') : '-'
  }

  goToChangelog () {
    this.$router.push({ name: 'change-log' })
  }
}
